import type { GetUserBranchAccountResponseAction } from './getUserBranchAccount.action';

export * from './getUserBranchAccount.action';

export type BranchAccountAction = GetUserBranchAccountResponseAction;
